import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import "./deletionRequests.css";
import Header from "../../../COMPONENTS/header/Header";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function DeletionRequests() {
  const [deletionRequests, setDeletionRequests] = useState([]);
  const navigate = useNavigate();
  const { auth } = useContext(AuthContext);
  const subscribername = auth.subscriberName;
  const digitalLendor = auth.digitalLendor;
  const staff = auth.staff;
  const role = auth.role;

  const fetchData = async () => {
    if (staff === "Yes" || subscribername === "BANK OF TANZANIA") {
      axios
        .get("/api/deletion-requests")
        .then((response) => {
          // Filter the data on the client-side based on the subscriberName
          const dataResponse = response.data.map((subscribers, index) => ({
            ...subscribers,
            rowNumber: index + 1,

          }));
          setDeletionRequests(dataResponse);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .get("/api/deletion-requests")
        .then((response) => {
          // Filter the data on the client-side based on the subscriberName
          const dataResponse = response.data
            .filter(
              (subscribers) => (subscribers["subscriber"] === subscribername || subscribers["subscriber"] === digitalLendor)
            )
            .map((subscribers, index) => ({
              ...subscribers,
              rowNumber: index + 1,
            }));
          setDeletionRequests(dataResponse);
        })
        .catch((error) => {
          //console.log(error);
        });
    }
  }

  useEffect(() => {
    fetchData();
  }, [subscribername, staff]);

  const handleView = (
    botWrittenDate,
    citReceivedDate,
    subject,
    status,
    subscriber,
    id
  ) => {
    const deletionRequestDetails = {
      botWrittenDate,
      citReceivedDate,
      subject,
      status,
      subscriber,
      id
    };
    navigate("/ViewDeletionRequestDetails", { state: { deletionRequestDetails } });
  };

  const handleProcess = (id) => {
    axios
      .post(
        "/api/process-deletion",
        { id }
      )
      .then((response) => {
        toast.success(response.data.success, {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchData();
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      });
  };

  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      flex: 0.1,
    },
    {
      field: "subject",
      headerName: "Subject",
      flex: 0.9,
    },
    {
      field: "subscriber",
      headerName: "Subscriber Name",
      flex: 1,
    },
    {
      field: "request_file",
      headerName: "Request Letter",
      flex: 0.5,
      renderCell: (params) => {
        return (
          <a
            href={"/api/request_file/" + params.row.request_file}
            target="_blank"
            rel="noreferrer"
          >
            <button className="viewPhotoButton">View File</button>
          </a>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.4,
      renderCell: (params) => {
        const activeStatus = params.value;
        const pendingStatus = activeStatus.includes("Pending");
        const onProgressStatus = activeStatus.includes("In Progress");
        const cellClassName = pendingStatus ? "pendingDeletion" : onProgressStatus ? "progressDeletion" : "completeDeletion";
        return <div className={cellClassName}>{activeStatus}</div>;
      },
    },
    {
      field: "response_file",
      headerName: "Response Letter",
      flex: 0.5,
      renderCell: (params) => {
        return (
          <>
            {params.row.response_file !== null && (
              <a
                href={"/api/response_file/" + params.row.response_file}
                target="_blank"
                rel="noreferrer"
              >
                <button className="viewPhotoButton">View File</button>
              </a>
            )}
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.3,
      renderCell: (params) => {
        return (
          <>
            <button
              className="viewActiveDisputesButton"
              onClick={() =>
                handleView(
                  params.row.bot_written_date,
                  params.row.cit_received_date,
                  params.row.subject,
                  params.row.status,
                  params.row.subscriber,
                  params.row.id
                )
              }
            >
              View
            </button>
          </>
        );
      },
    },
  ];

  if (role === 'compliance') {
    columns.push(
      {
        field: "process",
        headerName: "Process",
        flex: 0.4,
        renderCell: (params) => {
          return (
            <>
              {params.row.status === ('Pending') && (
                <button
                  className="processButton"
                  onClick={() => handleProcess(params.row.id)}
                >
                  Process
                </button>
              )}
            </>
          );
        },
      }
    )
  }
  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="8px">
          <Box m="8px">
            <Header
              title="DELETION REQUESTS"
              subtitle="View all deletion requests in the system"
            />
            <Box
              m="40px 0 0 0"
              height="100vh"
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                },
                "& .name-column--cell": {
                  color: "#2e7c67",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#bbbbbb",
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#f2f0f0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: "#a4a9fc",
                },
                "& .MuiCheckbox-root": {
                  color: `${"#1e5245"} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                  color: `${"#525252"} !important`,
                },
              }}
            >
              <DataGrid
                rows={deletionRequests}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
              />
            </Box>
          </Box>
        </Box>
      </main>
      <ToastContainer />
    </div>
  );
}

export default DeletionRequests;
